import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'

export default function useLocationsLinks({ isCoreLanguage }) {
  const { t } = useTranslation()
  const updatedLocationLink = useFeatureFlag('home_footer_updatedLocationLink').isOn

  return {
    id: 'locations',
    title: t('nav.locations', 'Locations'),
    hidden: !isCoreLanguage,
    subNav: [
      {
        id: 'slcLoc',
        text: t('nav.links.locations.slcLoc', 'Salt Lake FamilySearch Library'),
        url: `https://www.familysearch.org/${i18n.language}/library/` /* Prod link since this is not on beta */,
        linkName: 'ff_loc_slcLoc',
        dataTestId: 'ff_sl_fs_library',
        isNew: false,
      },
      {
        id: 'localLoc',
        text: t('nav.links.locations.localLoc', 'Find a Local FamilySearch Center'),
        url: updatedLocationLink
          ? `https://locations.familysearch.org/${i18n.language}`
          : '/fhcenters/locations' /* Prod link since this is not on beta */,
        linkName: 'ff_loc_localLoc',
        dataTestId: 'ff_local_fs_center',
        noPrependLocaleCode: true,
        isNew: false,
      },
    ],
  }
}
